import RadioGroup from '@/common/components/Inputs/RadioGroup/RadioGroup';

export default RadioGroup;
